<template>
  <div class="header">
    <h2>{{ title }}</h2>
    <div class="overlay">
      <div>
        <button v-if="showBack" class="back" @click="handleBack">
          <ArrowIcon class="arrow" />
        </button>
      </div>
      <div class="actions">
        <!-- @slot ボタンなどを配置するアクション領域 -->
        <slot />
      </div>
    </div>
  </div>
</template>

<script>
import ArrowIcon from '@/components/icons/arrow'
import Dialog from '@/components/molecules/ModalDialog'

export { default as Separator } from './Separator'

/**
 * ページヘッダー
 */
export default {
  name: 'PageHeader',
  components: {
    ArrowIcon,
  },
  props: {
    /** タイトル */
    title: String,
    /** 戻るボタンの表示 */
    showBack: { type: Boolean, default: false },
  },
  data() {
    return {
      STATIC_PATH,
    }
  },
  methods: {
    async handleBack() {
      /**
       * 戻るボタンのクリック
       * @event back
       */
      if (this.$store.state.app.editing) {
        if (await Dialog.confirmLeaveSetting(this.$route.path)) {
          this.$store.commit('app/editing', false)
          this.$emit('back')
        }
      } else {
        this.$emit('back')
      }
    },
  },
}
</script>

<style lang="postcss" scoped>
.header {
  align-items: center;
  background: var(--very-light-gray-4);
  border-bottom: 1px solid var(--border-color);
  box-sizing: border-box;
  display: flex;
  flex-shrink: 0;
  height: 56px;
  justify-content: center;
  position: relative;
}

h2 {
  font-weight: 600;
}

.overlay {
  align-items: center;
  box-sizing: border-box;
  display: flex;
  justify-content: space-between;
  padding: 8px;
  position: absolute;
  width: 100%;
}

.back {
  background: none;
  border: none;
  cursor: pointer;
  padding: 8px;

  .arrow {
    fill: var(--moderate-blue);
  }
}

.actions {
  align-items: center;
  display: flex;

  > :not(:first-child) {
    margin-left: 8px;
  }
}

.button {
  font-size: 15px;
  height: initial;
  line-height: 40px;
  min-width: 112px;
  width: initial;
}
</style>
